import { CostCalculation } from '@forms/CostCalculation'
import { TableSection } from '@ui/cases/TableSection'

import { Client } from './Client'
import { TableSectionConfig } from './config'
import { Header } from './Header'
import { Monitoring } from './Monitoring'
import { Overview } from './Overview'
import { Process } from './Process'
import { ProjectExecution } from './ProjectExecution'
import { ProjectScope } from './ProjectScope'
import { Result } from './Result'
import { Container, ContainerContent, WrapperSection } from './styles'

export function PlatformForImprovingDiagnosticAccuracy() {
  return (
    <Container>
      <Header />
      <ContainerContent>
        <WrapperSection>
          <TableSection config={TableSectionConfig} hexagon={false} />
        </WrapperSection>
        <Overview />
        <Client />
        <ProjectScope />
        <Process />
        <ProjectExecution />
        <Monitoring />
        <Result />
      </ContainerContent>
      <CostCalculation />
    </Container>
  )
}
